(function () {
  'use strict';

  if (customElements.get('pdp-gifting-assurance')) return;

  var UK_HOLIDAYS = {
    '2026-12-25': true,
    '2026-12-28': true,
    '2027-01-01': true,
    '2027-03-26': true,
    '2027-03-29': true,
    '2027-05-03': true,
    '2027-05-31': true,
    '2027-08-30': true,
    '2027-12-27': true,
    '2027-12-28': true,
    '2028-01-03': true,
    '2028-04-14': true,
    '2028-04-17': true,
    '2028-05-01': true,
    '2028-05-29': true,
    '2028-08-28': true,
    '2028-12-25': true,
    '2028-12-26': true
  };

  function londonParts(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'long'
    }).formatToParts(date);
    var map = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') map[part.type] = part.value;
    });
    return map;
  }

  function isoFromParts(parts) {
    return parts.year + '-' + parts.month + '-' + parts.day;
  }

  function addBusinessDays(count) {
    var today = londonParts(new Date());
    var cursor = new Date(Date.UTC(parseInt(today.year, 10), parseInt(today.month, 10) - 1, parseInt(today.day, 10), 12, 0, 0));
    var added = 0;
    while (added < count) {
      cursor.setUTCDate(cursor.getUTCDate() + 1);
      var parts = londonParts(cursor);
      if (parts.weekday !== 'Saturday' && parts.weekday !== 'Sunday' && !UK_HOLIDAYS[isoFromParts(parts)]) {
        added += 1;
      }
    }
    return cursor;
  }

  function formatArriveDate(date) {
    var parts = londonParts(date);
    var day = String(parseInt(parts.day, 10));
    var month = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      month: 'long'
    }).format(date);
    return parts.weekday + ' ' + day + ' ' + month;
  }

  var DURATION = 260;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function toggleDetails(details, collapse) {
    var current = details.open ? collapse.getBoundingClientRect().height : 0;
    var closing = details.open && !details.classList.contains('is-closing');

    if (details._hkAnimation) {
      details._hkAnimation.onfinish = null;
      details._hkAnimation.cancel();
    }

    var animation;
    if (closing) {
      details.classList.add('is-closing');
      animation = collapse.animate(
        [
          { height: current + 'px', opacity: 1 },
          { height: '0px', opacity: 0 }
        ],
        { duration: DURATION, easing: EASING }
      );
      animation.onfinish = function () {
        details.open = false;
        details.classList.remove('is-closing');
        details._hkAnimation = null;
      };
    } else {
      details.classList.remove('is-closing');
      details.open = true;
      var target = collapse.getBoundingClientRect().height;
      animation = collapse.animate(
        [
          { height: current + 'px', opacity: current ? 1 : 0 },
          { height: target + 'px', opacity: 1 }
        ],
        { duration: DURATION, easing: EASING }
      );
      animation.onfinish = function () {
        details._hkAnimation = null;
      };
    }

    details._hkAnimation = animation;
  }

  customElements.define(
    'pdp-gifting-assurance',
    class PdpGiftingAssurance extends HTMLElement {
      connectedCallback() {
        this.setupAccordions();

        var target = this.querySelector('[data-arrive-by]');
        if (!target) return;

        var days = parseInt(this.getAttribute('data-business-days') || '5', 10);
        if (isNaN(days) || days < 1) days = 5;

        var arrival = addBusinessDays(days);
        var formatted = formatArriveDate(arrival);
        var template = this.getAttribute('data-arrive-template') || 'Arrives by __DATE__';
        target.textContent = template.replace('__DATE__', formatted);
      }

      setupAccordions() {
        this.querySelectorAll('details').forEach(function (details) {
          var summary = details.querySelector(':scope > summary');
          var collapse = details.querySelector(':scope > .hk-pdp-ga__collapse');
          if (!summary || !collapse) return;

          summary.addEventListener('click', function (event) {
            if (reducedMotion.matches || typeof collapse.animate !== 'function') return;
            event.preventDefault();
            toggleDetails(details, collapse);
          });
        });
      }
    }
  );
})();
